<template>
  <b-navbar toggleable="md" type="light">
    <b-navbar-toggle
      id="navbarToggle"
      target="sidebar-1"
      v-b-toggle.sidebar-1
    ></b-navbar-toggle>
    <b-collapse is-nav id="nav_collapse">
      <b-nav vertical class="vertical_nav">
        <b-list-group id="listgroup">
          <b-list-group-item
            v-for="item in items"
            v-bind:key="item.id"
            :to="'/' + item.to"
            class="item py-2"
          >
            <b-row>
              <b-col cols="2">
                <b-img :src="item.image" height="32"></b-img>
              </b-col>
              <b-col cols="10" class="mt-1">
                <span class="ml-2"> {{ item.name }} </span>
              </b-col>
            </b-row>
          </b-list-group-item>
        </b-list-group>
      </b-nav>
    </b-collapse>

    <b-sidebar
      id="sidebar-1"
      title="Categories"
      shadow
      bg-variant="dark"
      text-variant="light"
      width="180px"
      backdrop
    >
      <b-nav vertical class="pl-2 test">
        <b-list-group id="listgroup">
          <b-list-group-item
            v-for="item in items"
            v-bind:key="item.id"
            :to="'/' + item.to"
            class="item py-2"
          >
            <b-row>
              <span class="ml-2"> {{ item.name }} </span>
            </b-row>
          </b-list-group-item>
        </b-list-group>
      </b-nav>
    </b-sidebar>
  </b-navbar>
</template>

<script>
export default {
  name: "vert_navbar",
  props: {
    msg: String,
  },
  data: function() {
    return {
      items: [
        {
          image:
            "https://web.poecdn.com/image/Art/2DItems/Amulets/AssassinUnique.png?v=e60041dda1c2c14bfaffcf1283eecea0&w=1&h=1&scale=1",
          to: "accs",
          name: "Accessories",
        },

        {
          image:
            "https://web.poecdn.com/image/Art/2DItems/Armours/BodyArmours/AvianBodyArmour.png?v=09ce3f04a672364ee31ae2694ea0b558&w=2&h=3&scale=1",
          to: "Armour",
          name: "Armour",
        },

        {
          image:
            "https://web.poecdn.com/image/Art/2DItems/Quivers/QuiverSpike-Point.png?v=1bd153027f337b59c30957890e223974&w=2&h=3&scale=1&shaper=1",
          to: "Bases",
          name: "Bases",
        },

        {
          image:
            "https://web.poecdn.com/image/Art/2DItems/Currency/BestiaryOrbFull.png?v=0d0f6c8509eaf231513fc8b9a5df4626&w=1&h=1&scale=1",
          to: "Beasts",
          name: "Beasts",
        },

        {
          image:
            "https://web.poecdn.com/image/Art/2DItems/Currency/CurrencyAddModToRare.png?v=1745ebafbd533b6f91bccf588ab5efc5&w=1&h=1&scale=1",
          to: "Currency",
          name: "Currency",
        },

        {
          image:
            "https://web.poecdn.com/image/Art/2DItems/Maps/Vaal01.png?v=3b21ce0cd4c0b9e8cf5db6257daf831a&w=1&h=1&scale=1",
          to: "fragment",
          name: "Fragments",
        },

        {
          image:
            "https://web.poecdn.com/image/Art/2DItems/Divination/InventoryIcon.png?v=a8ae131b97fad3c64de0e6d9f250d743&w=1&h=1&scale=1",
          to: "Divs",
          name: "Divs",
        },

        {
          image:
            "https://web.poecdn.com/image/Art/2DItems/Currency/Essence/Rage7.png?v=eedc0092ba0e7d4619fd2c3d5d4447a2&w=1&h=1&scale=1",
          to: "Essence",
          name: "Essences",
        },

        {
          image:
            "https://web.poecdn.com/image/Art/2DItems/Currency/Scarabs/NormalScarabBreach.png?v=16863ac16af551ed800fa73b404260b9&w=1&h=1&scale=1",
          to: "Scarab",
          name: "Scarab",
        },

        {
          image:
            "https://web.poecdn.com/image/Art/2DItems/Currency/Delirium/DeliriumOrbScarabs.png?v=2e2437a4994b36a24f97dbf6e763f522&w=1&h=1&scale=1",
          to: "DeliriumOrbs",
          name: "Delirium Orbs",
        },

        {
          image:
            "https://web.poecdn.com/gen/image/WzksMTQseyJmIjoiMkRJdGVtc1wvRmxhc2tzXC9Cb3R0bGVkUHVyaXR5IiwidyI6MSwiaCI6Miwic2NhbGUiOnRydWUsImxldmVsIjoxfV0/fb9e36a285/Item.png",
          to: "Flasks",
          name: "Flasks",
        },

        {
          image:
            "https://web.poecdn.com/image/Art/2DItems/Currency/Delve/FracturedFossil.png?v=11a6519b4c00c8660d5df8f19e692976&w=1&h=1&scale=1",
          to: "Fossil",
          name: "Fossils",
        },

        {
          image:
            "https://web.poecdn.com/image/Art/2DItems/Gems/Support/SupportPlus/MultipleAttacksPlus.png?v=1abaa015ea92a6f8a1f420744b8107e2&w=1&h=1&scale=1",
          to: "Gems",
          name: "Gems",
        },
        {
          image:
            "https://web.poecdn.com/image/Art/2DItems/Currency/Atlas/ProvingGroundValdosRest5.png?v=65e55778a369b3f6ffe3cc6c3202e904&w=1&h=1&scale=1",
          to: "Invitations",
          name: "Invitations",
        },
        {
          image:
            "https://web.poecdn.com/image/Art/2DItems/Maps/UltimatumTrialBase.png?v=1fce62b86652b4032ad6ac5e8b1114fd&w=1&h=1&scale=1",
          to: "Inscribed",
          name: "Inscribed",
        },
        {
          image:
            "https://web.poecdn.com/image/Art/2DItems/Jewels/GolemChaos.png?v=9156abcc1addb87ac5e44b6d07e00969&w=1&h=1&scale=1",
          to: "Jewels",
          name: "Jewels",
        },

        {
          image:
            "https://web.poecdn.com/image/Art/2DItems/Currency/Oils/GoldenOil.png?v=7640c249d21dbddf0425727a2ff9b4cf&w=1&h=1&scale=1",
          to: "Oil",
          name: "Oils",
        },

        {
          image:
            "https://web.poecdn.com/gen/image/WzI4LDE0LHsiZiI6IjJESXRlbXNcL01hcHNcL0F0bGFzMk1hcHNcL05ld1wvTWlub3RhdXIiLCJ3IjoxLCJoIjoxLCJzY2FsZSI6dHJ1ZSwibW4iOjgsIm10IjowLCJtaSI6MX1d/0063eb4324/Item.png",
          to: "Maps",
          name: "Maps",
        },

        {
          image:
            "https://web.poecdn.com/gen/image/WzI4LDE0LHsiZiI6IjJESXRlbXNcL01hcHNcL1N5bnRoZXNpc0Jvc3NHdWFyZGlhbk1hcCIsInciOjEsImgiOjEsInNjYWxlIjp0cnVlfV0/036f934afd/Item.png",
          to: "uniqueMaps",
          name: "Unique Maps",
        },

        { image: "", to: "enchants", name: "Enchants" },
        {
          image:
            "https://web.poecdn.com/image/Art/2DItems/Weapons/TwoHandWeapons/TwoHandSwords/Starforge.png?v=0ccd07f328eefaaf0dfa139d1912457b&w=2&h=4&scale=1",
          to: "weapons",
          name: "Weapons",
        },
        {
          image:
            "https://web.poecdn.com/gen/image/WzI1LDE0LHsiZiI6IjJESXRlbXMvQ3VycmVuY3kvQ2hhcmdlZENvbXBhc3MiLCJ3IjoxLCJoIjoxLCJzY2FsZSI6MX1d/ea8fcc3e35/ChargedCompass.png",
          to: "Sextants",
          name: "Sextants",
        },
        {
          image:
            "https://web.poecdn.com/image/Art/2DItems/Currency/Strongholds/IvoryWatchstone3.png?v=18db05af11a9b8104cc3cf97729dd004&w=1&h=1&scale=1",
          to: "Watchstones",
          name: "Watchstones",
        },
      ],
    };
  },
};
</script>

<style lang="scss">
.item {
  background-color: var(--dark);

  color: #bdd3e9;
  &.router-link-active {
    color: #42b983;
    background-color: var(--dark);
  }
}

#navbarToggle {
  background-color: var(--dark);
}
.vertical_nav {
  width: 100%;
}

.item:hover {
  background-color: var(--dark);
  color: #42b983;
}

li {
  margin-top: 5px;
}
a:hover {
  color: #42b983;
}
</style>
